<script>
  export let text;
</script>

<em style:font-style="italic">{text}</em>
